// removed by extract-text-webpack-plugin
module.exports = {"container":"_1_fUEFjt1au5Wfx4EnKDvx","button":"_2ktMBN38kW5603JsHpmEmt","buttons":"_1Mgwycuh2bZVAa4No_39iu","buttonB":"_3yUz0UWduHPZSlXITbd8d3","securitysat":"_3egwt8-fx3dR1Q-eYi7uEk"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Templates/Main/styles.css
// module id = 2961
// module chunks = 0